import React from 'react';
import PropTypes from 'prop-types';

import { useContext } from '@hooks';
import { mergeClasses } from '@utils';

import { ProductCardContext } from './ProductCard';

export default function ProductCardInformation({
  children,
  className,
  ...restProps
}) {
  useContext(
    ProductCardContext,
    'ProductCard.Information must be a child of ProductCard.'
  );

  return (
    <div
      className={mergeClasses(
        'px-2 text-xs font-semibold text-dark-gray @md:px-4 @md:text-sm',
        className
      )}
      {...restProps}
    >
      {children}
    </div>
  );
}

ProductCardInformation.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

ProductCardInformation.defaultProps = {
  className: ''
};
